angular.module('ihestiaWidgets.pza')
  .service('ihestiaPzaTagsSvc', ['ihestiaPzaAbstractSvc',
    function(ihestiaPzaAbstractSvc) {

      var PzaTagsSvc = function() {
        ihestiaPzaAbstractSvc.apply(this, arguments);

        this.resource = 'tags';
      };

      return new PzaTagsSvc();
    }]);